/**
 * Templates de contrato + placeholders + preview.
 * Usado no Step 6 do wizard de campanha (assinatura digital) — cada documento
 * (contrato / CCB / nota promissoria) tem seu proprio templateHtml editavel.
 */

export const DEFAULT_CONTRACT_TEMPLATE = `<div style="font-family: Arial, sans-serif; font-size: 11pt; line-height: 1.6; text-align: justify; padding: 20px;">
  <div style="text-align: center; font-weight: bold; font-size: 14pt; margin-bottom: 20px; text-transform: uppercase;">
    CONTRATO DE PRESTACAO DE SERVICOS
  </div>
  <p><strong>CONTRATANTE:</strong> {{NOME}}, inscrito(a) no CPF nº {{CPF}}, residente e domiciliado(a) na {{ENDERECO}}.</p>
  <p><strong>CONTRATADA:</strong> {{EMPRESA_RAZAO}}, CNPJ nº {{EMPRESA_CNPJ}}, com sede em {{EMPRESA_ENDERECO}}, representada por {{REPRESENTANTE_NOME}}, na qualidade de {{REPRESENTANTE_CARGO}}.</p>

  <p style="font-weight: bold; margin-top: 15px;">CLAUSULA PRIMEIRA - OBJETO</p>
  <p>A CONTRATADA prestara servicos de assessoria financeira ao CONTRATANTE. O valor total contratado eh de R$ {{VALOR_TOTAL}}, dividido em {{PARCELAS}} parcelas {{FREQUENCIA}} de R$ {{VALOR_PARCELA}}, com inicio em {{DATA_INICIO}} e termino em {{DATA_FIM}}.</p>

  <p style="font-weight: bold; margin-top: 15px;">CLAUSULA SEGUNDA - PAGAMENTO</p>
  <p>Os pagamentos serao realizados via PIX para a chave {{EMPRESA_PIX}} ({{EMPRESA_PIX_TIPO}}). Em caso de atraso, incidira multa e juros na forma da lei.</p>

  <p style="font-weight: bold; margin-top: 15px;">CLAUSULA TERCEIRA - FORO</p>
  <p>Fica eleito o foro da Comarca de {{EMPRESA_CIDADE}}/{{EMPRESA_ESTADO}}.</p>

  <p style="margin-top: 30px;">{{EMPRESA_CIDADE}}, {{DATA_ATUAL}}.</p>

  <div style="margin-top: 40px; display: flex; justify-content: space-between;">
    <div style="text-align: center; width: 45%;">
      <p style="border-top: 1px solid #000; padding-top: 4px; margin: 0;">{{NOME}}</p>
      <p style="margin: 0; font-size: 10pt;">CPF: {{CPF}}</p>
    </div>
    <div style="text-align: center; width: 45%;">
      <p style="border-top: 1px solid #000; padding-top: 4px; margin: 0;">{{REPRESENTANTE_NOME}}</p>
      <p style="margin: 0; font-size: 10pt;">{{EMPRESA_NOME}}</p>
    </div>
  </div>
</div>`;

export const CCB_TEMPLATE = `<div style="font-family: Arial, sans-serif; font-size: 11pt; line-height: 1.5; text-align: justify; padding: 20px;">
  <div style="text-align: center; font-weight: bold; font-size: 14pt; margin-bottom: 20px; text-transform: uppercase;">
    Cedula de Credito Bancario N&ordm; {{NUMERO_CONTRATO}}
  </div>
  <p><strong>EMITENTE:</strong> {{NOME}}, CPF n&ordm; {{CPF}}, residente e domiciliado(a) na {{ENDERECO}}.</p>
  <p><strong>CREDORA:</strong> {{EMPRESA_RAZAO}}, CNPJ n&ordm; {{EMPRESA_CNPJ}}, com sede em {{EMPRESA_ENDERECO}}.</p>

  <p style="font-weight: bold; margin-top: 20px;">1. VALOR PRINCIPAL, ENCARGOS E CONDICOES</p>
  <p>Pelo presente instrumento, o EMITENTE reconhece dever a CREDORA a quantia principal de R$ {{VALOR}}, acrescida dos encargos financeiros a taxa de {{JUROS}} ao periodo {{FREQUENCIA}}, totalizando R$ {{VALOR_TOTAL}} a ser pago em {{PARCELAS}} parcelas de R$ {{VALOR_PARCELA}} cada.</p>

  <p style="font-weight: bold; margin-top: 15px;">2. FORMA DE PAGAMENTO</p>
  <p>O pagamento sera realizado exclusivamente via PIX para a chave {{EMPRESA_PIX}} ({{EMPRESA_PIX_TIPO}}).</p>

  <p style="font-weight: bold; margin-top: 15px;">3. INADIMPLENCIA</p>
  <p>Em caso de inadimplemento, o EMITENTE ficara sujeito ao pagamento de multa moratoria e juros de mora, alem de eventual protesto e negativacao.</p>

  <p style="font-weight: bold; margin-top: 15px;">4. FORO</p>
  <p>Fica eleito o foro da Comarca de {{EMPRESA_CIDADE}}/{{EMPRESA_ESTADO}}.</p>

  <p style="margin-top: 30px;">{{EMPRESA_CIDADE}}, {{DATA_ATUAL}}.</p>

  <div style="margin-top: 40px; display: flex; justify-content: space-between;">
    <div style="text-align: center; width: 45%;">
      <p style="border-top: 1px solid #000; padding-top: 4px; margin: 0;">{{NOME}}</p>
      <p style="margin: 0; font-size: 10pt;">CPF: {{CPF}} (EMITENTE)</p>
    </div>
    <div style="text-align: center; width: 45%;">
      <p style="border-top: 1px solid #000; padding-top: 4px; margin: 0;">{{REPRESENTANTE_NOME}}</p>
      <p style="margin: 0; font-size: 10pt;">{{EMPRESA_NOME}} (CREDORA)</p>
    </div>
  </div>
</div>`;

export const NOTA_PROMISSORIA_TEMPLATE = `<div style="font-family: 'Courier New', monospace; font-size: 12pt; line-height: 1.6; padding: 30px; border: 2px solid #000;">
  <div style="text-align: center; font-weight: bold; font-size: 16pt; text-transform: uppercase; margin-bottom: 20px;">
    Nota Promissoria N&ordm; {{NUMERO_CONTRATO}}
  </div>
  <p style="text-align: right;">Valor: <strong>R$ {{VALOR_TOTAL}}</strong></p>
  <p style="margin-top: 30px; text-align: justify;">
    Aos {{DIA}} dias do mes de {{MES}} de {{ANO}}, pagarei por esta unica via de NOTA PROMISSORIA a
    <strong>{{EMPRESA_RAZAO}}</strong>, CNPJ n&ordm; {{EMPRESA_CNPJ}}, ou a sua ordem, a importancia
    liquida e certa de <strong>R$ {{VALOR_TOTAL}}</strong>, em moeda corrente nacional,
    pagavel em {{PARCELAS}} parcelas de R$ {{VALOR_PARCELA}}.
  </p>
  <p style="margin-top: 20px;">
    <strong>EMITENTE:</strong><br>
    Nome: {{NOME}}<br>
    CPF: {{CPF}}<br>
    Endereco: {{ENDERECO}}
  </p>
  <div style="margin-top: 60px; text-align: center;">
    <p style="border-top: 1px solid #000; padding-top: 4px; margin: 0 auto; width: 60%;">{{NOME}}</p>
    <p style="margin: 2px 0 0; font-size: 10pt;">Assinatura do Emitente</p>
  </div>
</div>`;

export interface ContractLibraryEntry {
  id: string;
  label: string;
  desc: string;
  html: string;
}

export const CONTRACT_LIBRARY: ContractLibraryEntry[] = [
  {
    id: "assessoria",
    label: "Prestacao de Servicos (Assessoria)",
    desc: "Contrato completo com clausulas de assessoria financeira. Padrao usado hoje.",
    html: DEFAULT_CONTRACT_TEMPLATE,
  },
  {
    id: "ccb",
    label: "CCB - Cedula de Credito Bancario",
    desc: "Titulo executivo extrajudicial, adequado quando ha PIX + assinatura digital.",
    html: CCB_TEMPLATE,
  },
  {
    id: "nota_promissoria",
    label: "Nota Promissoria",
    desc: "Modelo enxuto - uma pagina, valor total + prestacoes.",
    html: NOTA_PROMISSORIA_TEMPLATE,
  },
];

export function templateForTipo(tipo: string): string {
  if (tipo === "ccb") return CCB_TEMPLATE;
  if (tipo === "nota_promissoria_digital") return NOTA_PROMISSORIA_TEMPLATE;
  return DEFAULT_CONTRACT_TEMPLATE;
}

// Placeholders reconhecidos — bate com o RenderContractTemplateUseCase no backend.
export const VALID_PLACEHOLDERS = new Set([
  "NOME", "CPF", "RG", "NACIONALIDADE", "ESTADO_CIVIL", "PROFISSAO",
  "TELEFONE", "ENDERECO", "CEP", "CIDADE", "ESTADO", "BAIRRO",
  "VALOR", "VALOR_TOTAL", "VALOR_PARCELA", "VALOR_SOLICITADO",
  "VALOR_EXTENSO", "VALOR_TOTAL_EXTENSO", "VALOR_PARCELA_EXTENSO",
  "PARCELAS", "PARCELAS_EXTENSO", "FREQUENCIA", "FREQUENCIA_TEXTO",
  "JUROS", "JUROS_EXTENSO", "TAXA_JUROS", "NUMERO_CONTRATO",
  "PRAZO_TIPO", "DATA_INICIO", "DATA_FIM",
  "DATA_ATUAL", "DIA", "MES", "ANO",
  "EMPRESA_NOME", "EMPRESA_RAZAO", "EMPRESA_FANTASIA", "EMPRESA_CNPJ",
  "EMPRESA_TIPO", "EMPRESA_IE", "EMPRESA_IM",
  "EMPRESA_ENDERECO", "EMPRESA_LOGRADOURO", "EMPRESA_NUMERO",
  "EMPRESA_COMPLEMENTO", "EMPRESA_BAIRRO", "EMPRESA_CIDADE",
  "EMPRESA_ESTADO", "EMPRESA_CEP",
  "EMPRESA_TELEFONE", "EMPRESA_EMAIL", "EMPRESA_PIX", "EMPRESA_PIX_TIPO",
  "REPRESENTANTE_NOME", "REPRESENTANTE_CPF", "REPRESENTANTE_CARGO",
]);

export const REQUIRED_PLACEHOLDERS = [
  "NOME",
  "CPF",
  "VALOR",
  "PARCELAS",
  "EMPRESA_NOME",
  "EMPRESA_CNPJ",
];

export function analyzeContractPlaceholders(html: string): {
  unknown: string[];
  missing: string[];
} {
  const found = new Set<string>();
  html.replace(/\{\{([A-Z_]+)\}\}/g, (_, key) => {
    found.add(key);
    return "";
  });
  const unknown = Array.from(found).filter((k) => !VALID_PLACEHOLDERS.has(k));
  const missing = REQUIRED_PLACEHOLDERS.filter((k) => !found.has(k));
  return { unknown, missing };
}

// Dados de exemplo pra preview em tempo real.
const now = new Date();
export const CONTRACT_PREVIEW_VALUES: Record<string, string> = {
  NOME: "Fernanda Pollyanna Silva",
  CPF: "013.438.526-84",
  RG: "12.345.678-9",
  NACIONALIDADE: "brasileira",
  ESTADO_CIVIL: "solteira",
  PROFISSAO: "Comerciante",
  TELEFONE: "(31) 99988-7766",
  ENDERECO: "Rua das Flores, 100, Centro, Divinopolis/MG",
  CEP: "35500-000",
  CIDADE: "Divinopolis",
  ESTADO: "MG",
  BAIRRO: "Centro",
  VALOR: "1.000,00",
  VALOR_TOTAL: "1.270,00",
  VALOR_PARCELA: "63,50",
  VALOR_SOLICITADO: "1.000,00",
  VALOR_EXTENSO: "mil reais",
  VALOR_TOTAL_EXTENSO: "mil e duzentos e setenta reais",
  VALOR_PARCELA_EXTENSO: "sessenta e tres reais e cinquenta centavos",
  PARCELAS: "20",
  PARCELAS_EXTENSO: "vinte",
  FREQUENCIA: "diarias",
  FREQUENCIA_TEXTO: "diarios",
  JUROS: "1,35%",
  JUROS_EXTENSO: "um virgula trinta e cinco por cento",
  TAXA_JUROS: "1,35%",
  NUMERO_CONTRATO: "A1B2C3D4",
  PRAZO_TIPO: "dias uteis",
  DATA_INICIO: "01/10/2026",
  DATA_FIM: "31/10/2026",
  DATA_ATUAL: now.toLocaleDateString("pt-BR"),
  DIA: String(now.getDate()).padStart(2, "0"),
  MES: String(now.getMonth() + 1).padStart(2, "0"),
  ANO: String(now.getFullYear()),
  EMPRESA_NOME: "Emprestimo Diario",
  EMPRESA_RAZAO: "GONCALVES SOLUCOES ADMINISTRATIVAS LTDA",
  EMPRESA_FANTASIA: "Emprestimo Diario",
  EMPRESA_CNPJ: "00.000.000/0001-00",
  EMPRESA_TIPO: "LTDA",
  EMPRESA_IE: "isento",
  EMPRESA_IM: "-",
  EMPRESA_ENDERECO: "Av. Principal, 500, Centro, Divinopolis/MG",
  EMPRESA_LOGRADOURO: "Av. Principal",
  EMPRESA_NUMERO: "500",
  EMPRESA_COMPLEMENTO: "",
  EMPRESA_BAIRRO: "Centro",
  EMPRESA_CIDADE: "Divinopolis",
  EMPRESA_ESTADO: "MG",
  EMPRESA_CEP: "35500-000",
  EMPRESA_TELEFONE: "(37) 3221-0000",
  EMPRESA_EMAIL: "contato@emprestimodiario.com.br",
  EMPRESA_PIX: "00.000.000/0001-00",
  EMPRESA_PIX_TIPO: "CNPJ",
  REPRESENTANTE_NOME: "Joao Goncalves",
  REPRESENTANTE_CPF: "111.222.333-44",
  REPRESENTANTE_CARGO: "Socio Administrador",
};

export function renderContractPreview(html: string): string {
  return html.replace(/\{\{([A-Z_]+)\}\}/g, (match, key) => {
    return CONTRACT_PREVIEW_VALUES[key] ?? match;
  });
}

/**
 * Chips clicaveis que aparecem no editor pra inserir placeholders sem digitar.
 * Agrupados por categoria pra facilitar a escolha.
 */
export interface PlaceholderChip {
  key: string; // ex: "NOME"
  label: string; // ex: "Nome do cliente"
}

export const PLACEHOLDER_GROUPS: {
  titulo: string;
  chips: PlaceholderChip[];
}[] = [
  {
    titulo: "Cliente",
    chips: [
      { key: "NOME", label: "Nome" },
      { key: "CPF", label: "CPF" },
      { key: "RG", label: "RG" },
      { key: "ENDERECO", label: "Endereco" },
      { key: "TELEFONE", label: "Telefone" },
      { key: "ESTADO_CIVIL", label: "Estado civil" },
      { key: "PROFISSAO", label: "Profissao" },
      { key: "NACIONALIDADE", label: "Nacionalidade" },
    ],
  },
  {
    titulo: "Cobranca (vem da campanha)",
    chips: [
      { key: "VALOR", label: "Valor solicitado" },
      { key: "VALOR_TOTAL", label: "Valor total (c/ juros)" },
      { key: "VALOR_PARCELA", label: "Valor de cada parcela" },
      { key: "PARCELAS", label: "Nro parcelas" },
      { key: "JUROS", label: "Taxa de juros" },
      { key: "FREQUENCIA", label: "Frequencia (diario/etc.)" },
      { key: "DATA_INICIO", label: "Data de inicio" },
      { key: "DATA_FIM", label: "Data de termino" },
      { key: "NUMERO_CONTRATO", label: "Nro do contrato" },
    ],
  },
  {
    titulo: "Data",
    chips: [
      { key: "DATA_ATUAL", label: "Data de hoje" },
      { key: "DIA", label: "Dia" },
      { key: "MES", label: "Mes" },
      { key: "ANO", label: "Ano" },
    ],
  },
  {
    titulo: "Empresa",
    chips: [
      { key: "EMPRESA_NOME", label: "Nome fantasia" },
      { key: "EMPRESA_RAZAO", label: "Razao social" },
      { key: "EMPRESA_CNPJ", label: "CNPJ" },
      { key: "EMPRESA_ENDERECO", label: "Endereco" },
      { key: "EMPRESA_CIDADE", label: "Cidade" },
      { key: "EMPRESA_ESTADO", label: "Estado" },
      { key: "EMPRESA_PIX", label: "Chave PIX" },
      { key: "REPRESENTANTE_NOME", label: "Representante" },
      { key: "REPRESENTANTE_CARGO", label: "Cargo do representante" },
    ],
  },
];
